import { render, staticRenderFns } from "./CreateItemDialog.vue?vue&type=template&id=503d7b5a&"
import script from "./CreateItemDialog.vue?vue&type=script&lang=js&"
export * from "./CreateItemDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports